var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAnyQuestion = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 88 88"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 44,
  r: 44,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#472179",
  strokeWidth: 2.5,
  d: "M27 27a4 4 0 0 1 4-4h18.163a2 2 0 0 1 1.537.72l9.436 11.324a2 2 0 0 1 .464 1.28V61a4 4 0 0 1-4 4H31a4 4 0 0 1-4-4z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#472179",
  strokeLinecap: "round",
  strokeWidth: 2.5,
  d: "M50.1 24.05v9.55a2 2 0 0 0 2 2h7.45M35.11 47.331h16.8M35.4 54.5h8.4"
})));
export default SvgAnyQuestion;